import { Theme } from '@mui/material';

export const container = {
  zIndex: 'tooltip',
  width: { xs: '100%', sm: '320px', md: 'auto' },
  position: { xs: 'fixed', md: 'absolute' },
  bottom: {
    xs: '0',
    md: '0',
  },
  margin: '0 auto',
  right: { xs: '0', md: '0' },
  left: { xs: '0', md: 'auto' },
  display: { xs: 'flex', md: 'block' },
  justifyContent: { xs: 'center', md: 'unset' },
  alignItems: { xs: 'center', md: 'unset' },
  transition: 'all 0.5s ease',
};

export const cardContainer = {
  maxWidth: { xs: '100vw', sm: '300px' },
  minWidth: { xs: '100vw', sm: '300px' },
  height: { md: '100%' },
  maxHeight: { xs: '380px', md: '100%' },
  textAlign: 'left',
};

export const cardContent = {
  margin: 0,
  height: '100%',
  padding: '0px!important',
};

export const headerContainer = {
  boxSizing: 'content-box',
  height: '40px',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '10px',
};

export const avatar = { height: '28px!important', width: '28px' };

export const headerTitle = {
  fontSize: 16,
  fontWeight: '600',
  padding: 0,
  lineHeight: '28px',
  textAlign: 'left',
  flexGrow: 1,
  marginLeft: '12px',
};

export const closeIcon = (theme: Theme) => ({
  color: theme.palette.text.primary,
  padding: 0.5,
  justifyContent: 'flex-end',
});

export const optionsContainer = (theme: Theme) => ({
  '& .MuiGrid-item:nth-of-type(odd)': {
    background:
      theme.palette.mode === 'light'
        ? theme.palette.primary.light
        : theme.palette.grey[50],
  },
  background: theme.palette.elevation01?.main,
  color: theme.palette.text.primary,
  height: '100%',
});

export const optionItem = {
  padding: '12px 16px!important',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
};

export const optionTitle = { fontSize: 14, fontWeight: '600' };

export const optionValue = { fontSize: 14, padding: 0, textAlign: 'right' };
